const HomePage = function () {
  return (
    <div>
      <h1>Home</h1>
    </div>
  );
}

export default HomePage;